/** Textes « echeances » — le français fait foi. */
export const echeances = {
  badge: { depasse: 'Dépassée', proche: 'Bientôt', jamais: 'Jamais faite', ok: 'À jour' },
  erreurChargement: "Cette liste n'a pas pu être chargée.",
  chargementImpossible: 'Chargement impossible',
  controle: 'Contrôle technique',
  entretien: 'Entretien',
  sousControle: 'Une voiture sans contrôle valide ne peut plus rouler du jour au lendemain',
  sousPeriode: (km: string, u: string) => `Toutes les ${km} ${u} · une ligne par voiture, la plus urgente en premier`,
  sousDefaut: 'Une ligne par voiture, la plus urgente en premier',
  enregistrerIntervention: 'Enregistrer une intervention',
  aTraiter: (n: number) => `${n} voiture(s) à traiter`,
  depassees: (n: number) => `${n} dépassée(s)`,
  proches: (n: number, liste: string) => `${n} arrive(nt) à échéance : ${liste}.`,
  rien: 'Rien à traiter',
  aucuneApproche: "Aucune voiture n'approche de son échéance",
  seuil: (u: string) => ` — le seuil d’alerte est de 1 000 ${u}`,
  toutesVoitures: 'Toutes les voitures',
  parVoiture: 'Par voiture',
  aucuneFlotte: 'Aucune voiture dans la flotte',
  aucuneFiltre: 'Aucune voiture pour ce filtre',
  col: {
    vehicule: 'Véhicule', numero: 'N° de contrôle', expire: 'Expire le', echeance: 'Échéance', etat: 'État',
    compteur: 'Compteur', derniere: 'Dernière', prochaine: 'Prochaine',
  },
  noteEntretien1: 'Une voiture passe en rouge ',
  noteEntretienSeuil: (u: string) => `sous les 1 000 ${u}`,
  noteEntretien2: " : c'est la distance qu'elle peut faire en une seule location. Le kilométrage vient des relevés saisis sur l'écran « Mes voitures » et des états des lieux.",
  noteControle: "Le contrôle technique est aussi visible sur la fiche de chaque voiture, avec l'assurance et la vignette. Une voiture dont le contrôle a expiré ne doit plus sortir.",
};
